import { BudgetProposalT } from 'routes/BudgetModule/config/types';
import {
    getResourceIdEventField,
    getResourceVentilationString,
} from 'routes/BudgetModule/helpers/budgetProposalHelpers';
import { MANTY_BLACK } from 'styles/theme';
import {
    BUDGET_LINE_SOFTWARE_ID,
    CHAPTER_ID,
    ENRICHED_OPERATION_SOFTWARE_ID,
    INSCRIPTION_ORIGIN,
    NATURE_ID,
} from '../constants';
import { HistoryUpdateContentT, HistoryOriginT } from '../types';

export const stringToColor = (string: string | null): string => {
    // Taken from here https://mui.com/components/avatars/#letter-avatars
    // It matches a color with a string so that it looks random and consistent
    if (!string) return MANTY_BLACK;
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.substr(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
};

export const getSimpleUpdateEventTranslation = (
    content: Partial<HistoryUpdateContentT>,
    origin: HistoryOriginT,
    budgetProposal: BudgetProposalT,
    t: TranslationT,
    sourceTable: string | null,
    label?: string,
): string => {
    // if budget line in update content, the inscription has been moved from one bl to another
    if (BUDGET_LINE_SOFTWARE_ID in content && origin === INSCRIPTION_ORIGIN) {
        // if history update content has no budget line 'after' value that means
        // the inscription has become orphan
        if (!content.budgetLineSoftwareId?.after) {
            return t('budgetHistory.eventInscriptionMadeOrphan');
        }
        return t('budgetHistory.eventMoveImputation');
    }

    // if operation in update content, the inscription has been moved from one operation to another
    if (ENRICHED_OPERATION_SOFTWARE_ID in content) {
        return t('budgetHistory.eventMoveOperation', {
            context: sourceTable,
            value: label ?? 'PAS DE VALEUR',
        });
    }

    if (CHAPTER_ID in content) {
        return t('budgetHistory.eventMoveChapter', {
            chapter: label ?? 'PAS DE CHAPITRE',
        });
    }

    if (NATURE_ID in content) {
        return t('budgetHistory.eventMoveNature', {
            nature: label ?? 'PAS DE NATURE',
        });
    }

    // if history update content has no resource 'after' value that means
    // the inscription has become wandering
    const resourceIdField = getResourceIdEventField(budgetProposal.by);
    if (resourceIdField in content && !content[resourceIdField]?.after) {
        return t('budgetHistory.eventInscriptionMadeWandering', {
            ventilation: getResourceVentilationString([budgetProposal], t),
        });
    }
    return t('budgetHistory.unknownUpdate');
};
